import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./offers_mirrored_block.css";
import "../standalone_calendar/standalone_calendar";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
